<template>
  <div>
    <shipblu-prompt
      class="shipment-modal withdraw-modal"
      @close="closeModal"
      :active.sync="withdrawalRequestModal"
      :title="$t('Withdrawal request')"
      :buttons-hidden="true">
      <div class="mt-[32px]">
        <p class="text-young-night text-[16px] font-medium">{{ $t('Enter the amount you want to withdraw') }}</p>
        <shipblu-input autocomplete="nofill" v-validate="`required|decimal|min_value:1|max_value:${walletbalance}`" name="withdrawal amount" v-model="requestedAmount" type="text" class="w-full mt-[16px]" @blur="validateCashCollections">
          <p class="slot-item text-industrial-revolution">{{ $t('EGP') }}</p>
        </shipblu-input>
        <p class="text-danger text-sm" v-if="requestedAmount > walletbalance">{{ $t('The withdrawal amount field must be less than the wallet balance') }}</p>
        <p class="text-danger text-sm" v-else v-show="errors.has('withdrawal amount')">{{ $t(errors.first('withdrawal amount')) }}</p>
        <p class="text-young-night text-[14px] mt-[12px]">{{ $t('Your transfer will be processed within 3 business days and subject to any applicable transfer fees') }}</p>
      </div>
      <div class="mt-[47px] grid grid-cols-2 gap-[12px]">
        <shipblu-button size="small" :textButton="$t('Confirm')" @click="withdrawalRequestSend()" :disabled="requestedAmount ? false : true"/>
        <shipblu-button size="small" color="secondary" :textButton="$t('Cancel')" @click="closeModal()"/>
      </div>
    </shipblu-prompt>
  </div>
</template>

<script>
import ShipbluPrompt from './../../layouts/components/ShipBluPrompt.vue'
import {sendRequest} from './../../http/axios/requestHelper.js'
import vSelect from 'vue-select'
import i18nData from '../../i18n/i18nData.js'

export default {
  props: ['withdrawalRequestModal', 'walletbalance'],
  data () {
    return {
      requestedAmount: ''
    }
  },
  methods: {
    closeModal () {
      this.$validator.pause()
      this.requestedAmount = ''
      this.$emit('withdrawalRequestModal', false)
    },
    validateCashCollections () {
      if (this.requestedAmount === '') {
        return
      }
      const value = parseFloat(this.requestedAmount)
      if (isNaN(value)) {
        this.requestedAmount = (0).toFixed(2)
        
      } else {
        this.requestedAmount = value.toFixed(2)
      }
      this.$emit('customerData', this.customerData)
    },
    withdrawalRequestSend () {
      this.$validator.validateAll().then(result => {
        if (result) {
          sendRequest(false, false, this, 'api/v1/merchant-wallet-refunds/', 'post',  {requested_amount : this.requestedAmount}, true,
            () => {
              this.$vs.notify({
                color:'success',
                title: i18nData[this.$i18n.locale]['Success'],
                text: i18nData[this.$i18n.locale]['Wallet refund has been created successfully!'],
                position: 'top-center'
              })
              this.$router.push({
                query:{
                  tab: 'withdraw-requests' 
                }
              })
              this.closeModal()
            }
          )
        }
      })
    }
  },
  watch: {
    withdrawalRequestModal (val) {
      if (val) {
        this.$validator.resume()
      }
    }
  },
  components: {
    ShipbluPrompt,
    vSelect
  }
}
</script>
<style>
.con-vs-dialog.shipment-modal.withdraw-modal .vs-dialog {
    max-width: 530px !important;
}
</style>